
import api from "@/api/index"; //ABP API接口
import { Vue, Component } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";
import { MessageBox } from "element-ui";

import {
  PayrollRequisitionDto,
  AuditNodeDto,
  AuditUserLogType,
  AuditUserLogStatus, PaymentCategoryScope
} from "@/api/appService";

import EditPayrollRequisition from "./components/edit-payrollRequisition.vue";
import AgileAuditTag from "@/components/AgileAuditTag/index.vue";
import PaymentCategorySelect from "@/components/PaymentCategorySelect/index.vue";
import AuditFlowDetailButton from "@/components/AuditFlowDetailButton/index.vue";
import ExportButton from "@/components/ExportButton/index.vue";
@Component({
  name: "PayrollRequisitionList",
  components: {
    ExportButton,
    AuditFlowDetailButton,
    PaymentCategorySelect,
    EditPayrollRequisition,
    AgileAuditTag
  }
})
export default class PayrollRequisitionList extends ElementTableView {
  tableItems: PayrollRequisitionDto[] = [];
  private orgList = {};
  private categoryList = {};
  async created() {
    await this.fetchStores();
    await this.fetchCategories();
    await this.fetchData();
  }

  queryForm: any = {
    /**  */
    amount: undefined,
    /**  */
    amountStart: undefined,
    /**  */
    amountEnd: undefined,
    /**  */
    categoryId: undefined,
    /**  */
    creationTimeStart: undefined,
    /**  */
    creationTimeEnd: undefined,
    /** 请求的门店 */
    orgId: undefined,
    /** 需要审批的状态 */
    audit: undefined,
    /** 现在审批的状态 */
    auditStatus: undefined
  };

  get scopeMapping(){
    return PaymentCategoryScope.PayrollRequisition;
  }

  get hostType(){
    return AuditUserLogType.PayrollRequisition;
  }

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.payrollRequisition
      .getAll({
        ...this.queryForm,
        sorting: this.table.sorting,
        skipCount: this.skipCount,
        maxResultCount: this.table.pagesize
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  ///获取所有门店
  async fetchStores() {
    await api.client.getStores().then(res => {
      this.orgList = res;
    });
  }

  ///获取所有分类
  async fetchCategories() {
    await api.paymentCategoryService.getCategoryList().then(res => {
      this.categoryList = res;
    });
  }

  // 新建
  handleCreate() {
    (this.$refs.editForm as any).show = true;
  }

  // 编辑
  handleEdit(index: number, row: any) {
    (this.$refs.editForm as any).show = true;
    (this.$refs.editForm as any).form = row;

    console.warn("%cu must reWrite this method", "color:#0048BA;");
  }

  // 删除
  async handleDelete(index: number, row: PayrollRequisitionDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.payrollRequisition
        .delete({
          id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.fetchData();
        });
    });
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }

  //  提交审核
  async handleStartAudit(item: PayrollRequisitionDto) {
    await api.payrollRequisition.startAudit({ body: item }).then(res => {
      this.$message.success("已提交");
    });
  }

  // 审核通过
  async pass(item: PayrollRequisitionDto, node: AuditNodeDto) {
    console.log(item, node);
    await api.project.audit({
      body: {
        hostId: `${item.id}`,
        hostType: AuditUserLogType.PayrollRequisition,
        auditFlowId: node.auditFlowId,
        auditNodeId: node.id,
        status: AuditUserLogStatus.Pass,
        desc: `${this.$store.getters['user/name']} 通过了审核`
      }
    });
  }
}
